import { FC } from 'react';
import { Avatar, Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';

import { formatLargeNumber, formatPercentage } from '@shared/helpers/number';

export const SpecializationDetails: FC<Specializations.Specialization> = specialization => {
  return (
    <>
      <Box px={2} mb={3}>
        <Typography variant="body1" mb={1}>{specialization.description}</Typography>
        {specialization.careerOutlook && (
          <Stack direction="row" spacing={1}>
            {specialization.careerOutlook.salaryRangeEntry && (
              <Paper
                component={Box}
                variant="outlined"
                p={1}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box>
                    <Typography variant="subtitle1" lineHeight={1} mb={0.4}>Entry salary</Typography>
                    <Typography variant="body1" fontWeight={600} lineHeight={1}>{formatLargeNumber(specialization.careerOutlook.salaryRangeEntry)}</Typography>
                  </Box>
                </Stack>
              </Paper>
            )}
            {specialization.careerOutlook.salaryRangeMid && (
              <Paper
                component={Box}
                variant="outlined"
                p={1}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box>
                    <Typography variant="subtitle1" lineHeight={1} mb={0.4}>Average salary</Typography>
                    <Typography variant="body1" fontWeight={600} lineHeight={1}>{formatLargeNumber(specialization.careerOutlook.salaryRangeMid)}</Typography>
                  </Box>
                </Stack>
              </Paper>
            )}
          </Stack>
        )}
      </Box>
      {specialization.careerOutlook && (
        <Box px={2} mb={2}>
          {specialization.careerOutlook.jobGrowthProjection && (
            <>
              <Typography variant="subtitle1" mb={0.5}>Growth projection</Typography>
              <Typography variant="body1" mb={1}>{specialization.careerOutlook.jobGrowthProjection}</Typography>
            </>
          )}
          {specialization.careerOutlook.employmentRate && (
            <Box display="inline-block" mr={1}>
              <Paper
                component={Box}
                variant="outlined"
                p={1}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Avatar variant="rounded" sx={theme => ({ width: 32, height: 32, backgroundColor: theme.palette.secondary.main, color: 'common.white' })}>
                    <TrendingUp/>
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle1" lineHeight={1} mb={0.4}>Employment</Typography>
                    <Typography variant="body1" fontWeight={600} lineHeight={1}>{formatPercentage(specialization.careerOutlook.employmentRate)}</Typography>
                  </Box>
                </Stack>
              </Paper>
            </Box>
          )}
        </Box>
      )}
      {specialization.careerOutlook && specialization.careerOutlook.careerPaths?.length > 0 && (
        <Box
          px={2}
          mb={2}
        >
          <Typography variant="subtitle1" mb={0.5}>Career paths</Typography>
          {specialization.careerOutlook.careerPaths?.map(path => (
            <Box key={path} display="inline-block" mr={1} mb={1}>
              <Chip
                label={path}
                color="default"
                size="small"
              />
            </Box>
          ))}
        </Box>
      )}
      {/* Admission Requirements */}
      <Box
        p={2}
        width="100%"
        sx={theme => ({ backgroundColor: theme.palette.fourtiary.light })}
      >
        <Stack direction="column" spacing={3} mb={1}>
          {specialization.admissionRequirements && (
            <Box>
              <Typography variant="subtitle1" mb={0.5}>Admission requirements</Typography>
              <Typography variant="body1">{specialization.admissionRequirements}</Typography>
            </Box>
          )}
          {specialization.recommendedSkills && (
            <Box>
              <Typography variant="subtitle1" mb={0.5}>Recommended skills</Typography>
              <Typography variant="body1">{specialization.recommendedSkills}</Typography>
            </Box> 
          )}
          {specialization.entranceExams && (
            <Box>
              <Typography variant="subtitle1" mb={0.5}>Entrance exams</Typography>
              <Typography variant="body1">{specialization.entranceExams}</Typography>
            </Box>
          )}
          {specialization.entranceExams && (
            <Box>
              <Typography variant="subtitle1" mb={0.5}>Language requirements</Typography>
              <Typography variant="body1">{specialization.entranceExams}</Typography>
            </Box>
          )}
        </Stack>
      </Box>
    </>
  );
};
